import { render, staticRenderFns } from "./video-frame.vue?vue&type=template&id=04b6b17c&scoped=true&"
import script from "./video-frame.vue?vue&type=script&lang=js&"
export * from "./video-frame.vue?vue&type=script&lang=js&"
import style0 from "./video-frame.vue?vue&type=style&index=0&id=04b6b17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6b17c",
  null
  
)

export default component.exports